import React, { useState, useEffect } from 'react';

import { Modal, message } from 'antd';

import { GetErrorMessage } from '../Utility';
import api from '../api';

type ParsFunc = {
    Open: boolean;
    onClose: any;
    idSocieta: undefined | null | number;
    idAllegato: null | number;
    idDocumento: null | number;
    nomeFile: string;
};

export default function AllegatoPreview(pars: ParsFunc) {
    const [isOpen, setisOpen] = useState(pars.Open);
    const [fileUrl, setFileUrl] = useState('');
    const [type, setType] = useState('');

    useEffect(() => {
        getFileContentx();
    }, [pars.idAllegato, pars.idDocumento]);

    async function getFileContentx() {
        try {
            if (pars.idDocumento === null && pars.idAllegato === null) return;

            let response;
            if (pars.idDocumento === null)
                response = await api.get(
                    'CRM/Allegato?idSocieta=' + pars.idSocieta + '&idAllegato=' + pars.idAllegato,
                    { responseType: 'arraybuffer' }
                );
            else
                response = await api.get(
                    'Documenti/Allegato?idSocieta=' + pars.idSocieta + '&idDocumento=' + pars.idDocumento,
                    { responseType: 'arraybuffer' }
                );

            const tp = response.headers['content-type'];
            setType(tp);
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const urlx = URL.createObjectURL(blob);

            setFileUrl(urlx);

            setisOpen(true);
        } catch (error) {
            message.error(GetErrorMessage(error), 5);
        }
    }

    const downloadFile = (url: string) => {
        const element = document.createElement('a');
        element.href = url;
        element.download = pars.nomeFile;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        setisOpen(false);
    };

    useEffect(() => {
        if (fileUrl && !type.includes('pdf') && !type.includes('text') && !type.startsWith('image')) {
            downloadFile(fileUrl);
        }
    }, [fileUrl]);

    const closeModal = () => {
        setFileUrl('');
        setisOpen(false);
        pars.onClose();
    };

    return (
        <Modal
            open={isOpen}
            onCancel={() => closeModal()}
            onOk={() => setisOpen(false)}
            destroyOnClose={true}
            style={{ top: '4%', padding: 0 }}
            width="80vw"
            footer={null}
        >
            {fileUrl ? (
                <div style={{ width: '100%', height: '100%' }}>
                    {type.includes('pdf') || type.includes('text') ? (
                        <iframe
                            title="Preview"
                            style={{ width: '100%', height: '80vh', marginTop: '25px' }}
                            src={fileUrl}
                            frameBorder="0"
                        />
                    ) : type.startsWith('image') ? (
                        <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                    ) : null}
                </div>
            ) : null}
        </Modal>
    );
}
